import { Component, OnInit, ViewChild, Input } from '@angular/core';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { BaseChartDirective } from 'ng2-charts';
import Chart from '../../../../../../node_modules/chart.js';
import { ChartLegendItem } from 'chart.js';

@Component({
	selector: 'app-achieve-plan',
	templateUrl: './achieve-plan.component.html',
	styleUrls: ['./achieve-plan.component.css']
})
export class AchievePlanComponent implements OnInit {
  @Input() userAchievePlan: any;
  @ViewChild(BaseChartDirective, {static: true}) private chart: BaseChartDirective;
  @ViewChild(BaseChartDirective, {static: true}) private chartBullet: BaseChartDirective;
  math = Math;
  maxVolumeAct: number;
  maxVolumeExp: number;
  maxVolumeOfTwo: number;
  greenActive: boolean = true;
  sizeSales: any[] = [];
  dataGrafActual: number[] = [];
  dataGrafExpected: number[] = [];
  dataGrafProcent: number[]= [];
  year: number[] = [];
  selectedIndex: number = 0;
  currentYear: number = 0;

	PercPlanYear: string;
	Remained: number;
	RemainedPerc: number;
	ActualSalesYear: number = 0;
	PlanSalesYear: number = 0;
	PercPlanYearScale : string;

  constructor() { }

//forlinechart

public lineChartOptions = {
	scaleShowVerticalLines: false,
	responsive: true,
	tooltips: {
		callbacks: {
			 label: function(tooltipItem) {
							return tooltipItem.yLabel;
			 }
		}
	},
	plugins: {
		datalabels: {
			anchor: 'end',
			align: 'end',
			font: {
				size: 14,
				family: 'Gerbera',
			},
			formatter: function(value) {
				return Math.round(value).toLocaleString() + '%';
			}
		}
	},
	scales: {
		yAxes: [
			{
				ticks: {
					beginAtZero: true,
					suggestedMin: -15,
					display:false,
					stepSize: 10
				},                
				beforeBuildTicks: function(context){
					return context.max = context.max + 50
				},
				gridLines: {
					display: false,
					drawBorder: false,
				}
			}
		],
		xAxes: [
			{
				display:false,
				gridLines:{
					display: false
				}
			}
		]
	}
};
public lineChartLabels = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
public lineChartType = 'bar';
public lineChartLegend = false;
public lineChartData = [
	{
		data:this.dataGrafProcent,
		label: "проценты КСП",
		type: 'line'
	}
];
public lineChartPlugins = [pluginDataLabels];
public lineChartColors = [
	{
		borderColor: 'rgb(219, 227, 136)',
		pointBackgroundColor: 'rgb(255, 255, 255)',
		borderWidth:2,
		pointRadius:5,
		fill: false,
		backgroundColor: "rgb(219, 227, 136)"
	}
];

	//for barchart

  public barChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true,
    hover: {
      mode: 'dataset'
    },
    onHover: function(event){
      event 
    },
    legend: {
      position: 'bottom',
      align: 'end',
      reverse: true,
      labels:{
        boxWidth: 15,
        fullWidth: false,
        fontFamily: 'Gerbera',
        fontSize: 14,
        fontColor: '#636873',
        padding: 25,
      },
      onClick: function(e, legendItem){}
    },
    plugins: {
      datalabels: {
        display: false
      }
    },
    scales: {
      yAxes: [
        {
          id: "Fact",
          stacked: true,
          offset: true,
          ticks: {
            beginAtZero: true,
            suggestedMin: -10,
            stepSize: 50,
            display:false
          },
          beforeBuildTicks: function(context){
            return context.max 
          },
          gridLines: {
            display: false,
            drawBorder: false,
          }
        },
        {
          id: "Expected",
          stacked: true,
          offset: true,
          ticks: {
            beginAtZero: true,
            suggestedMin: -10,
            stepSize: 50,
            display:false,
          },
          beforeBuildTicks: function(context){
            return context.max 
          },
          gridLines: {
            display: false,
            drawBorder: false,
          }
        }
      ],
      xAxes: [
        {
          id: 'x-axis-1',
          categoryPercentage: 0.6,
          type:'category',
          offset: true, 
          barPercentage: 1,
          barThickness: 50,          
          stacked: true,
          ticks:{
            fontFamily: 'Gerbera',
          },
          gridLines:{
            display: false
          }
        }, {
          id: 'x-axis-2',
          categoryPercentage: 0.6,
          barPercentage: 1,
          display: false,
          type:'category',
          offset: true,
          barThickness: 30, 
          stacked: true,
          ticks:{
            fontFamily: 'Gerbera',
          },
          gridLines:{
            display: false,
            offsetGridLines: true
          }
        }
      ]
    }
  };
  public barChartLabels = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartData = [
    {
      data: this.dataGrafExpected, 
      label: 'план тыс. ₽',
      yAxisID: 'Expected',
      stack: '1s',
      xAxisID: 'x-axis-1',
      hidden: false
    },
    {
      data: this.dataGrafActual, 
      label: 'факт тыс. ₽',
      yAxisID: 'Fact',
      stack: '1s',
      xAxisID: 'x-axis-2',
    }
  ];
  public barChartPlugins = [pluginDataLabels];
  public barChartColors = [
    {
      backgroundColor: 'rgb(255, 255, 255, 0.1)',
      borderColor: 'rgb(226, 193, 227)',
      borderWidth: 2,
      borderSkipped: false,
    },
    {
      backgroundColor: 'rgb(219, 227, 136)',
      borderColor: 'rgb(219, 227, 136)',
      borderWidth: 2,
      borderSkipped: false,
    },
    {
      borderColor: 'rgb(219, 227, 136)',
      pointBackgroundColor: 'rgb(219, 227, 136)',
      fill: false,
      backgroundColor: "rgb(219, 227, 136)"
    }
  ];

	ngOnInit() {
	}

	ngOnChanges() {
		if(this.userAchievePlan.sales != undefined){
			
			let summVolume = 0;
			let summPalanValume = 0; 
			this.sizeSales = this.userAchievePlan.sales;
			let oldYear = null;
			this.currentYear = new Date().getFullYear();


      for(let summ of this.userAchievePlan.sales){
        if(summ.year == this.currentYear){
          if(summ.volume != undefined){
            this.ActualSalesYear += summ.volume;
            this.PlanSalesYear += summ.volume_plan;
            
          }
        }
      }
      if(this.PlanSalesYear != 0){
        let pers = this.math.round((this.ActualSalesYear / this.PlanSalesYear) * 100);
        this.PercPlanYear = pers + '%';
        this.PercPlanYearScale = pers > 100 ? '100%' : pers + '%';
      }
      else{
        this.PercPlanYear = '0%'
      }
      
      this.Remained = this.math.round(this.PlanSalesYear - this.ActualSalesYear);
      if(this.PlanSalesYear != 0){
        this.RemainedPerc = this.math.round(100 - (this.ActualSalesYear / this.PlanSalesYear) * 100);
      }
      else{
        this.RemainedPerc = 0;
      }
      for(let item of this.sizeSales) {
        if(item.year != oldYear){
          oldYear = item.year;
          this.year.push(item.year);
        }

        if(item.year == this.currentYear){
          let plan = item.volume_plan / 1000;
          let fact = item.volume_fact / 1000;
          let percentNsz = 0
          percentNsz = (item.volume_fact / item.volume_plan) * 100;
          this.dataGrafActual.push(Math.round(fact));
          this.dataGrafExpected.push(Math.round(plan));
          this.dataGrafProcent.push(Number(percentNsz.toFixed(2)));
        }
        this.maxVolumeAct = Math.max.apply(Math, this.dataGrafActual.map(function(o) { return o; }));
        this.maxVolumeExp = Math.max.apply(Math, this.dataGrafExpected.map(function(o) { return o; }));
        this.maxVolumeOfTwo = this.maxVolumeExp > this.maxVolumeAct ? this.maxVolumeExp : this.maxVolumeAct;
        
        // bar chart options changes here
        var that = this;
        this.barChartOptions = {
          scaleShowVerticalLines: false,
          responsive: true,          
          hover: {
            mode: 'dataset'
          },
          onHover: function(event){
            event 
          },
          legend: {
            position: 'bottom',
            align: 'end',
            reverse: true,
            labels:{
              boxWidth: 15,
              fullWidth: false,
              fontFamily: 'Gerbera',
              fontSize: 14,
              fontColor: '#636873',
              padding: 50
            },
            onClick: function(e, legendItem){
              var index = legendItem.datasetIndex;
              var ci = this.chart;
              var alreadyHidden = (ci.getDatasetMeta(index).hidden === null) ? false : ci.getDatasetMeta(index).hidden;
              var meta = ci.getDatasetMeta(index);
    
              if (index === 0) {
                if (!alreadyHidden) {
                  meta.hidden = true;
                } else if (meta.hidden === true) {
                  meta.hidden = false;
                }
              } else if (index === 1) {
                if (!alreadyHidden) {
                  meta.hidden = true;
                } else if (meta.hidden === true) {
                  meta.hidden = false;
                }
              }
            ci.update();
            }
          },
          plugins: {
            datalabels: {
              display: false
            }
          },
          scales: {
            yAxes: [
              {
                id: "Fact",
                stacked: true,
                offset: true,
                ticks: {
                  beginAtZero: true,
                  suggestedMin: -(that.maxVolumeOfTwo * 10.5 / 100),
                  stepSize: 50,
                  display:false,
                },
                beforeBuildTicks: function(context){
                  return context.max = that.maxVolumeOfTwo * 1.7
                },
                gridLines: {
                  display: false,
                  drawBorder: false,
                }
              },
              {
                id: "Expected", 
                stacked: true,
                offset: true,
                ticks: {
                  beginAtZero: true,
                  suggestedMin: -(that.maxVolumeOfTwo * 9.5 / 100),
                  stepSize: 50,
                  display:false,
                },
                beforeBuildTicks: function(context){
                  return context.max = that.maxVolumeOfTwo * 1.7
                },
                gridLines: {
                  display: false,
                  drawBorder: false,
                }
              }
            ],
            xAxes: [
              {
                id: 'x-axis-1',
                categoryPercentage: 0.6,
                barPercentage: 0.9,
                type:'category',
                offset: true,
                barThickness: 50,          
                stacked: true,
                ticks:{
                  fontFamily: 'Gerbera',
                },
                gridLines:{
                  display: false,
                }
                
              }, {
                id: 'x-axis-2',
                stacked: true,
                barThickness: 35,  
                type:'category',
                offset: true,
                display: false,
                categoryPercentage: 0.6,
                barPercentage: 0.9,
                ticks:{
                  fontFamily: 'Gerbera',
                },
                gridLines:{
                  display: false,
                  offsetGridLines: true
                }
              }
            ]
          }
        }

        // linechart options changes here
        this.lineChartOptions = {
          scaleShowVerticalLines: false,
          responsive: true,
          tooltips: {
            callbacks: {
               label: function(tooltipItem) {
                      return tooltipItem.yLabel;
               }
            }
          },
          plugins: {
            datalabels: {
              anchor: 'end',
              align: 'end',
              font: {
                size: 12,
                family: 'Gerbera',
              },
              formatter: function(value) {
                return value.toFixed(2).toLocaleString() + '%';
              }
            }
          },
          scales: {
            yAxes: [
              {  
                ticks: {
                  beginAtZero: true,
                  suggestedMin: -20,
                  display:false,
                  stepSize: 10
                },                
                beforeBuildTicks: function(context){
                  if(context.max <=150){
                    return context.max = context.max + 100
                  } 
                  if(context.max <=200 && context.max > 150){
                    return context.max = context.max + 150
                  }
                  if(context.max <=250 && context.max > 200){
                    return context.max = context.max + 180
                  }
                },
                gridLines: {
                  display: false,
                  drawBorder: false,
                }
              }
            ],
            xAxes: [
              {
                display:false,
                gridLines:{
                  display: false
                }
              }
            ]
          }
        };
      }
      this.roundedChart();
      this.pluginsHeight();
      this.year.reverse();
      for(let year of this.year){
        if(year == this.currentYear){
          this.selectedIndex = this.year.indexOf(year);
        } else{
          this.selectedIndex = null
        }
      }
      this.dataGrafActual.reverse();
      this.dataGrafExpected.reverse();
      this.dataGrafProcent.reverse();
      this.chart.chart.update();
      this.chartBullet.chart.update();
      Chart.defaults.global.defaultFontFamily = 'Gerbera'; 
      Chart.defaults.global.defaultFontStyle = 'normal';
    }
  }
 
  pluginsHeight(){
    Chart.pluginService.register({
      afterDatasetsDraw: function (context, easing) {
        var ctx = context.chart.ctx;
        context.data.datasets.forEach(function (dataset) {
          if(dataset.label == 'план тыс. ₽' || dataset.label == 'факт тыс. ₽'){
            for (var i = 0; i < dataset.data.length; i++) {
              var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
              var textY = model.y;
              if(dataset.label == 'план тыс. ₽'){
                  ctx.textAlign = 'start';
                  ctx.anchor = 'start';
                  ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
                  ctx.fillStyle = '#842D87';
                  ctx.save();
                  let xpos = dataset.data[i] <= 9999 ? 
                                    (dataset.data[i] <= 999 ? 
                                      (dataset.data[i] <= 99 ? (model.x - 7)
                                      : 
                                      (model.x -10)) 
                                    : (model.x - 14)) 
                                  : (model.x  - 17);
                  ctx.translate(xpos, 88);
                  ctx.fillText(dataset.data[i].toLocaleString(), 0, 0);
                  ctx.restore();
              } else if(dataset.label == 'факт тыс. ₽'){
                  ctx.textAlign = 'start';
                  ctx.anchor = 'center';
                  ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, 'normal', Chart.defaults.global.defaultFontFamily);
                  ctx.fillStyle = '#000000';
                  ctx.save();
                  let xpos = dataset.data[i] <= 9999 ? 
                                    (dataset.data[i] <= 999 ? 
                                      (dataset.data[i] <= 99 ? (model.x - 7)
                                      : 
                                      (model.x -10)) 
                                    : (model.x - 14)) 
                                  : (model.x  - 17);
                  ctx.translate(xpos, 70);
                  ctx.fillText(dataset.data[i].toLocaleString(), 0, 0);
                  ctx.restore();
              } 
            }
          }
        })
      }
    })
  }

  onClickChangeYear(event:any, index: number){
    event.preventDefault();
    this.ActualSalesYear = 0;
    this.PlanSalesYear = 0;
    this.PercPlanYear = null;
    this.Remained = 0;
    this.RemainedPerc = 0;
    this.selectedIndex = index;
    this.dataGrafActual = [];
    this.dataGrafExpected = [];
    this.dataGrafProcent = [];
    this.chart.chart.update();
    this.chartBullet.chart.update();
    var yearSelected = event.target.innerText;
    if(this.userAchievePlan.sales != undefined){
      this.sizeSales = this.userAchievePlan.sales;


			for(let summ of this.userAchievePlan.sales){
				if(summ.year == yearSelected){
					if(summ.volume != undefined){
						this.ActualSalesYear += summ.volume;
						this.PlanSalesYear += summ.volume_plan;
						
					}
				}
			}

			if(this.PlanSalesYear != 0){
				let pers = this.math.round((this.ActualSalesYear / this.PlanSalesYear) * 100);
				this.PercPlanYear = this.math.round((this.ActualSalesYear / this.PlanSalesYear) * 100) + '%';
				this.PercPlanYearScale = pers > 100 ? '100%' : pers + '%';
			}
			else{
				this.PercPlanYear = '0%'
			}
			
			this.Remained = this.math.round(this.PlanSalesYear - this.ActualSalesYear);
			if(this.PlanSalesYear != 0){
				this.RemainedPerc = this.math.round(100 - (this.ActualSalesYear / this.PlanSalesYear) * 100);
			}
			else{
				this.RemainedPerc = 0;
			}


			for(let item of this.sizeSales) {
				if(item.year == yearSelected){
					let plan = item.volume_plan / 1000;
          let fact = item.volume_fact / 1000;
          let percentNsz = (item.volume_fact / item.volume_plan) * 100;
					this.dataGrafActual.push(Math.round(fact));
					this.dataGrafExpected.push(Math.round(plan));
					this.dataGrafProcent.push(Number(percentNsz.toFixed(2)));
				} 
      }
      
      this.maxVolumeAct = Math.max.apply(Math, this.dataGrafActual.map(function(o) { return o; }));
      this.maxVolumeExp = Math.max.apply(Math, this.dataGrafExpected.map(function(o) { return o; }));
      this.maxVolumeOfTwo = this.maxVolumeExp > this.maxVolumeAct ? this.maxVolumeExp : this.maxVolumeAct;

			this.dataGrafActual.reverse();
			this.dataGrafExpected.reverse();
			this.dataGrafProcent.reverse();
			this.barChartData = [
				{
					data: this.dataGrafExpected, 
					label: 'план тыс. ₽',
					yAxisID: 'Expected',
					stack: '1s',
					xAxisID: 'x-axis-1',
				},
				{
					data: this.dataGrafActual, 
					label: 'факт тыс. ₽',
					yAxisID: 'Fact',
					stack: '1s',
					xAxisID: 'x-axis-2',
				}
			];
			this.lineChartData = [
				{
					data:this.dataGrafProcent,
					label: "проценты КСП",
					type: 'line'
				}
			];
			this.chart.chart.update();
			this.chartBullet.chart.update();
			return true;
		}
	}

	roundedChart(){
		 Chart.elements.Rectangle.prototype.draw = function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var left, right, top, bottom, signX, signY, borderSkipped, radius;
			var borderWidth = vm.borderWidth;
			// Set Radius Here
			// If radius is large enough to cause drawing errors a max radius is imposed
			var cornerRadius = 3;
	
			if (!vm.horizontal) {
					// bar
					left = vm.x - vm.width / 2;
					right = vm.x + vm.width / 2;
					top = vm.y;
					bottom = vm.base;
					signX = 1;
					signY = bottom > top? 1: -1;
					borderSkipped = vm.borderSkipped || 'bottom';
			} else {
					// horizontal bar
					left = vm.base;
					right = vm.x;
					top = vm.y - vm.height / 2;
					bottom = vm.y + vm.height / 2;
					signX = right > left? 1: -1;
					signY = 1;
					borderSkipped = vm.borderSkipped || 'left';
			}
	
			// Canvas doesn't allow us to stroke inside the width so we can
			// adjust the sizes to fit if we're setting a stroke on the line
			if (borderWidth) {
					// borderWidth shold be less than bar width and bar height.
					var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
					borderWidth = borderWidth > barSize? barSize: borderWidth;
					var halfStroke = borderWidth / 2;
					// Adjust borderWidth when bar top position is near vm.base(zero).
					var borderLeft = left + (borderSkipped !== 'left'? halfStroke * signX: 0);
					var borderRight = right + (borderSkipped !== 'right'? -halfStroke * signX: 0);
					var borderTop = top + (borderSkipped !== 'top'? halfStroke * signY: 0);
					var borderBottom = bottom + (borderSkipped !== 'bottom'? -halfStroke * signY: 0);
					// not become a vertical line?
					if (borderLeft !== borderRight) {
							top = borderTop;
							bottom = borderBottom;
					}
					// not become a horizontal line?
					if (borderTop !== borderBottom) {
							left = borderLeft;
							right = borderRight;
					}
			}
	
			ctx.beginPath();
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = borderWidth;
	
			// Corner points, from bottom-left to bottom-right clockwise
			// | 1 2 |
			// | 0 3 |
			var corners = [
					[left, bottom],
					[left, top],
					[right, top],
					[right, bottom]
			];
	
			// Find first (starting) corner with fallback to 'bottom'
			var borders = ['bottom', 'left', 'top', 'right'];
			var startCorner = borders.indexOf(borderSkipped, 0);
			if (startCorner === -1) {
					startCorner = 0;
			}
	
			function cornerAt(index) {
					return corners[(startCorner + index) % 4];
			}
	
			// Draw rectangle from 'startCorner'
			var corner = cornerAt(0);
			ctx.moveTo(corner[0], corner[1]);
	
			for (var i = 1; i < 4; i++) {
					corner = cornerAt(i);
					var nextCornerId = i+1;
					if(nextCornerId == 4){
							nextCornerId = 0
					}
	
					var nextCorner = cornerAt(nextCornerId);
	
					var width = corners[2][0] - corners[1][0];
					var height = corners[0][1] - corners[1][1];
					var x = corners[1][0];
					var y = corners[1][1];
					
					var radius:any = cornerRadius;
					
					// Fix radius being too large
					if(radius > height/2){
							radius = height/2;
					}if(radius > width/2){
							radius = width/2;
					}
	
					ctx.moveTo(x + radius, y);
					ctx.lineTo(x + width - radius, y);
					ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
					ctx.lineTo(x + width, y + height - radius);
					ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
					ctx.lineTo(x + radius, y + height);
					ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
					ctx.lineTo(x, y + radius);
					ctx.quadraticCurveTo(x, y, x + radius, y);
	
			}
	
			ctx.fill();
			if (borderWidth) {
					ctx.stroke();
			}
	}; 
	}

}